import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";
import { PhoneMask } from "ComponentsUI/Masks";

const styles = (theme) => ({
	root: {
		width: "100%",
		height: "50px",
		border: `1px solid ${theme.palette.colors.disabled}`,
		borderRadius: "10px",
		backgroundColor: "transparent",
		padding: "0 21px",
		fontSize: "16px",
		fontFamily: theme.fonts.light,
		color: theme.palette.colors.darkSlateBlue2,
	},
	isError: {
		borderColor: theme.palette.colors.coralPink,
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			height: "40px",
		},
	},
});

class Component extends React.Component {
	render() {
		let classes = this.props.classes;
		let { error, isPhone, ...rest } = this.props;

		if (!isPhone) {
			return (
				<input
					className={classNames(classes.root, {
						[classes.isError]: error,
					})}
					{...rest}
				/>
			);
		}

		return (
			<PhoneMask
				className={classNames(classes.root, {
					[classes.isError]: error,
				})}
				{...rest}
			/>
		);
	}
}

export default withStyles(styles)(Component);
